import React from 'react';
import {
  Switch, Route, Redirect
} from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useQuery } from 'react-query';
// import api from '../../api';
// import SignUp from '../../container/SignUp';
// import SignIn from '../../container/SignIn';
// import ResetPassword from '../../container/ResetPassword';
// import SetPassword from '../../container/SetPassword';
// import Quiz from '../../container/Quiz';
// import Loader from '../../container/Loader';
// import Dashboard from '../../container/Dashboard';
import CommingSoon from '../../container/CommingSoon';
import LandingPage from '../../container/LandingPage';
// import { RootState, persistor } from '../../redux';
// import UserActions from '../../redux/user/actions';
import Game from '../../container/Game';
import Launch from '../../container/Launch';
// import PastGames from '../../container/PastGames';
// import Verify from '../../container/Verify';
// import useNotifications from '../../hooks/useNotifications';
// import nijiLogo from '../../assets/images/Logo.png';
import PrivacyPolicy from '../../container/PrivacyPolicy';
import TermsOfService from '../../container/TermsOfService';
// import AuthActions from '../../redux/auth/actions';
// const AuthContext = React.createContext({ isAuthenticated: false, quizPassed: false });

// eslint-disable-next-line @typescript-eslint/naming-convention
// const AuthRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) => (
//       <AuthContext.Consumer>
//         {({ isAuthenticated }) => (isAuthenticated ? (
//           <Component {...props} />
//         ) : (
//           <Redirect to={{ pathname: '/' }} />
//         ))}
//       </AuthContext.Consumer>
//     )}
//   />
// );

// eslint-disable-next-line @typescript-eslint/naming-convention
// const UnauthRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) => (
//       <AuthContext.Consumer>
//         {({ isAuthenticated }) => (!isAuthenticated? (
//           <Component {...props} />
//         ) : ( 
//           <Redirect to="/dashboard" /> 
//         ))}
//       </AuthContext.Consumer>
//     )}
//   />
// );

const Routes: React.FunctionComponent = () => {
  // useNotifications();
  // const dispatch = useDispatch();
  // const profileQuery = useQuery('profile', api.auth.getProfile, { manual: true });
  // const auth = useSelector((state: RootState) => state.auth);
  // const user = useSelector((state: RootState) => state.user);
  // const history = useHistory();
  // const isAuthenticated = Boolean(auth.token && auth.expiration > Date.now());

  return (
    <Switch>
      <Route exact path="/launch" component={Launch} />
      <Route exact path="/game" component={Game} />
      <Route exact path="/privacy-policy" component={PrivacyPolicy} />
      <Route exact path="/terms-of-service" component={TermsOfService} />
      <Route exact path="/niji-qa" component={CommingSoon} />
      <Route exact path="/" component={LandingPage} />
      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
